import React, {JSX} from "react";
import { Link, useNavigate } from "react-router-dom";
import { AppBar, IconButton, Toolbar, Typography } from "@mui/material";
import { ArrowBackOutlined, Menu } from "@mui/icons-material";
import { useNavigationBarStyles } from "./css";
import * as routes from "../app/routes";

interface INavigationBar {
  moduleName?: JSX.Element | string;
  modulePath?: string;
  isDocumentList?: boolean;
  btnText?: string;
  whiteBackground?: boolean;
}

function NavigationBar(props: INavigationBar) {
  const { moduleName, modulePath, btnText, isDocumentList, whiteBackground } =
    props;
  const { classes, cx } = useNavigationBarStyles();
  const isButton = typeof btnText !== "undefined";
  const navigate = useNavigate();

  const handleBack = (event: React.MouseEvent<HTMLAnchorElement>) => {
    event.preventDefault();

    const historyIndex = window.history.state?.idx;
    if (typeof historyIndex === "number" && historyIndex > 0) {
      navigate(-1);
    } else if (modulePath) {
      navigate(modulePath, { replace: true });
    }
  };

  return (
    <div className={classes.container}>
      <AppBar
        position="fixed"
        color="secondary"
        elevation={0}
        classes={{
          root: cx(
            { [classes.root]: !whiteBackground },
            { [classes.rootWhite]: whiteBackground }
          ),
        }}
      >
        <Toolbar>
          <div className={classes.gridContainer}>
            <div className={cx({ [classes.leftItem]: isButton })}>
              {/* Document List, possibility to refresh list*/}
              {modulePath && isDocumentList && (
                <Typography variant="body2" className={classes.textAndIcon}>
                  {moduleName ? moduleName : "mscan"}
                </Typography>
              )}

              {/* Detailed information, possibility to go back */}
              {modulePath && !isDocumentList && (
                <Link
                  to={modulePath}
                  className={cx(classes.link, classes.icon)}
                  onClick={handleBack}
                >
                  <Typography variant="h2" className={classes.textAndIcon}>
                    <ArrowBackOutlined fontSize="small" />
                    {moduleName ? moduleName : "mscan"}
                  </Typography>
                </Link>
              )}
            </div>

            <div className={cx({ [classes.rightItem]: isButton })}>
              <div>
                {/*Back to Options list  */}
                <Link
                  to={routes.ROUTE_OPTIONS.path}
                  state={{ from: modulePath }}
                  className={classes.link}
                >
                  <IconButton className={classes.icon} size="medium">
                    <Menu />
                  </IconButton>
                </Link>
              </div>
            </div>
          </div>
        </Toolbar>
      </AppBar>
      {/* Workaround for css. Otherwise other elements hide behind appbar */}
      <Toolbar />
    </div>
  );
}

export default React.memo(NavigationBar);
